class SlideCartComponent {
  constructor(slideCartDisplayId, slideCartContainerClass, headerCartButtonClass, slideCartCloseButtonId) {
    this.slideCartDisplay = document.getElementById(slideCartDisplayId);
    this.slideCartContainer = document.querySelector(`.${slideCartContainerClass}`);
    this.headerCartButton = document.querySelector(`.${headerCartButtonClass}`);
    this.slideCartCloseButton = document.getElementById(slideCartCloseButtonId);
    this.body = document.body;

    if (!this.slideCartDisplay || !this.slideCartContainer || !this.headerCartButton || !this.slideCartCloseButton) {
      console.warn('SlideCartComponent: Missing necessary DOM elements.');
      return;
    }

    this.initialize();
  }

  initialize = () => {
    this.bindEvents();
  };

  bindEvents = () => {
    this.slideCartContainer.addEventListener('click', (event) => event.stopPropagation());
    this.slideCartDisplay.addEventListener('click', this.closeSlider);
    this.headerCartButton.addEventListener('click', this.openSlider);
    this.slideCartCloseButton.addEventListener('click', this.closeSlider);
  };

  openSlider = () => {
    this.slideCartDisplay.classList.add('show');
    fetchAndUpdateProductRecommendations();
    this.body.setAttribute('slide-cart-opened', '');
    setTimeout(() => {
      this.slideCartContainer.classList.add('open');
      this.updateCashbackFlag('30%');
    }, 200);
  };

  closeSlider = () => {
    this.slideCartContainer.classList.remove('open');
    this.body.removeAttribute('slide-cart-opened')
    setTimeout(() => {
      this.slideCartDisplay.classList.remove('show');
      this.updateCashbackFlag('50%');
    }, 100);
  };

  updateCashbackFlag = (newTopPos) => {
    if (!window.location.pathname.includes('/collections/')) {
      const cashbackflag = document.querySelector('.needsclick');
      if (cashbackflag) {
        cashbackflag.style.transition = 'top 0.3s ease';
        cashbackflag.style.top = newTopPos;
      }
    }
  };
}

const handleUpsellDisplay = () => {
  const upsellItems = document.querySelector('.slide-cart--upsell-container');

  if (upsellItems) {
    const isActiveMobile = upsellItems.getAttribute('data-active-mobile') === 'true';
    const isActiveDesktop = upsellItems.getAttribute('data-active-desktop') === 'true';
    const prods = upsellItems.querySelectorAll('.slide-cart--upsell-items .slide-cart--upsell-product:not(.slide-cart-upsell-product-hidden)');

    if (prods.length === 0 || (!isActiveMobile && window.innerWidth <= 768) || (!isActiveDesktop && window.innerWidth > 768)) {
      upsellItems.style.display = 'none';
    } else {
      upsellItems.style.display = 'flex';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.slideCartComponent = new SlideCartComponent(
    'shopify-section-ee-slide-cart',
    'slide-cart--container',
    'site-nav__link--cart',
    'slide-cart-close-button',
  );
  handleUpsellDisplay();
});

const upsellAddToCartHandler = async (event, productId) => {
  // Prevent the default action (following the link)
  event.preventDefault();
  const productContainer = event.target.closest('.slide-cart--upsell-product');
  productContainer.classList.add('item-updating');

  let data = {};
  let noscriptContent = document.querySelector('noscript[id="products_gwp"]');

  if (typeof noscriptContent !== 'undefined' && noscriptContent !== null) {
    noscriptContent = noscriptContent.innerText;
    data = JSON.parse(noscriptContent)['gwp'];
  }

  const formData = await getVariantsToAdd(data, { id: productId, quantity: 1 });
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      cart_update();
      productContainer.classList.add('slide-cart-upsell-product-hidden');
    })
    .catch((error) => {
      productContainer.classList.remove('item-updating');
      console.error('Error:', error);
    });
};

const getVariantsToAdd = async (data, form) => {
  const id = form.id;
  const quantity = form.quantity;
  let items = [
    {
      id: id,
      quantity: quantity,
    },
  ];

  if (data['product_x'] === null && data['product_y'] === null) {
    return { items: items };
  }

  let [productGwp, productX, productY] = [false, false, false];
  let gwp = {
    handleX: null,
    handleY: null,
  };
  let cart = {};

  gwp['id'] = data['id'];
  gwp['handle'] = data['handle'];

  if ('product_gwp' in data && data['product_gwp'] !== null) {
    gwp['productGwpId'] = data['product_gwp']['id'];
    gwp['variantGwpId'] = data['product_gwp']['variants'][0].id;
    productGwp = true;

    if ('variant_gwp' in data && data['variant_gwp'] !== '') gwp['variantGwpId'] = data['variant_gwp'];
  }

  if ('product_x' in data && data['product_x'] !== null) {
    gwp['handleX'] = data['product_x']['handle'];
    gwp['productXId'] = data['product_x']['id'];
    gwp['variantXId'] = data['product_x']['variants'][0].id;
    productX = true;

    if (gwp['handle'] === gwp['handleX']) gwpEnable = true;
  }

  if ('product_y' in data && data['product_y'] !== null) {
    gwp['handleY'] = data['product_y']['handle'];
    gwp['productYId'] = data['product_y']['id'];
    gwp['variantYId'] = data['product_y']['variants'][0].id;
    productY = true;

    if (gwp['handle'] === gwp['handleY']) gwpEnable = true;
  }

  if (gwp['handle'] === gwp['handleX'] || data['handle'] === gwp['handleY']) {
    if (productGwp) {
      let req = await fetch('/cart.js');
      cart = await req.json();
    }

    if (cart.items.length > 0) {
      let itemCount = cart.items.filter((item) => '_gwp' in item.properties && 'PRODUCT ID' in item.properties);
      //if (itemCount.length > 0) return { items: itemsOnRadar };
    }

    items[0]['properties'] = {
      _gwp: gwp['handle'] === gwp['handleX'] ? gwp['productXId'] : gwp['productYId'],
    };

    let product = {
      id: gwp['variantGwpId'],
      quantity: 1,
      properties: {
        _gwp: gwp['variantGwpId'],
        'PRODUCT ID': gwp['productGwpId'],
      },
    };

    let itemCountX = cart.items.filter((item) => '_gwp' in item.properties && item.properties._gwp == gwp['productXId']);
    let itemCountY = cart.items.filter((item) => '_gwp' in item.properties && item.properties._gwp == gwp['productYId']);

    if (productX && productY) {
      if (gwp['handle'] === gwp['handleX'] && itemCountY.length > 0) items.push(product);
      if (gwp['handle'] === gwp['handleY'] && itemCountX.length > 0) items.push(product);
    } else if (productX && itemCountX.length <= 0) {
      items.push(product);
    }
  }

  return { items: items };
};

const updateStepper = (currentCartValue, thresholds) => {
  const hasOneChild = (element) => element.children.length === 1;
  const progressTracker = document.querySelector('.progress-tracker');

  if (hasOneChild(progressTracker)) {
    progressTracker.classList.add('progress-tracker-single');
  } else {
    progressTracker.classList.remove('progress-tracker-single');
  }

  let currentProductFree = '';
  let currentAmountAwayFromFreeGift = 0;
  const progressTrackerContainer = document.querySelector('.progress-tracker-container');
  const isFreeGiftEnabled = progressTrackerContainer.getAttribute('data-is-free-gift-enabled');

  let shipping_bar_active = false;
  let shipping_bar_threshold;

  if (progressTrackerContainer) {
    shipping_bar_active = progressTrackerContainer.getAttribute('data-is-freeShipping');
    shipping_bar_threshold = parseInt(progressTrackerContainer.getAttribute('data-freeShipping-threshold'), 10);

    if (shipping_bar_active == 'true' && !isNaN(shipping_bar_threshold)) {
      // Insert the shipping_bar_threshold into the thresholds array
      thresholds.push(shipping_bar_threshold * 100);

      // Sort the thresholds array in ascending order
      thresholds.sort((a, b) => a - b);
    }

    if (isFreeGiftEnabled == 'true') {
      // Get the first threshold and add 1 to it
      const firstThreshold = thresholds.length > 0 ? thresholds[0] : 9900;
      const freeGiftThreshold = firstThreshold + 1;
      
      // Insert the free gift into the thresholds array to add it as a step
      thresholds.push(freeGiftThreshold);

      // Sort the thresholds array in ascending order
      thresholds.sort((a, b) => a - b);
    }
    
    console.log("thresholds aaa", thresholds);
  }

  const progressSteps = document.querySelectorAll('.progress-step');
  const progressStepsLength = progressSteps.length;

  // Hide the progress tracker container if no progress steps are present
  if (progressStepsLength === 0) {
    document.querySelector('.progress-tracker-container').style.display = 'none';
    return;
  } else {
    document.querySelector('.progress-tracker-container').style.display = 'flex';
  }

  // Add classes to the first and last progress lines
  progressSteps[0].querySelector('.progress-line').classList.add('progress-line-first');
  progressSteps[progressStepsLength - 1].querySelector('.progress-line').classList.add('progress-line-last');

  // Reset progress visuals
  progressSteps.forEach((step) => {
    step.querySelector('.progress-line-fill').style.width = '0%';
    step.querySelector('.circle-fill').style.width = '0%';
    step.classList.remove('stepper-completed');
  });

  // If the current cart value is zero, exit the function to avoid any progress
  if (currentCartValue === 0) {
    currentProductFree = progressSteps[0].getAttribute('data-product-title');
    currentAmountAwayFromFreeGift = (thresholds[0] - currentCartValue) / 100;
    document.querySelector('.progress-tracker-heading p').textContent =
      `You are ${currentAmountAwayFromFreeGift} USD away from ${currentProductFree}`;
    document.querySelector('.progress-tracker-heading span').innerText = '';
    document.querySelector('.progress-tracker-heading h5').style.display = 'block';
    return;
  }

  let isLastStepCompleted = false;
  let lastProductTitle = '';

  thresholds.forEach((threshold, index) => {
    if (currentCartValue >= threshold) {
      // Fully fill the progress line as completed
      progressSteps[index].querySelector('.progress-line-fill').style.width = '100%';
      // Fully fill the circle as well
      progressSteps[index].querySelector('.circle-fill').style.width = '100%';
      // Add 'stepper-completed' class
      progressSteps[index].classList.add('stepper-completed');

      if (index === thresholds.length - 1) {
        isLastStepCompleted = true;
        lastProductTitle = progressSteps[index].getAttribute('data-product-title');
      }
    } else {
      let previousThreshold = index === 0 ? 0 : thresholds[index - 1];
      if (!currentProductFree) {
        currentProductFree = progressSteps[index].getAttribute('data-product-title');
        currentAmountAwayFromFreeGift = (threshold - currentCartValue) / 100;

        // Fully fill ongoing step's progress line
        progressSteps[index].querySelector('.progress-line-fill').style.width = '100%';

        // Partially fill the circle based on progression
        let fillWidth = ((currentCartValue - previousThreshold) / (threshold - previousThreshold)) * 100;
        progressSteps[index].querySelector('.circle-fill').style.width = `${fillWidth}%`;

        document.querySelector('.progress-tracker-heading p').textContent =
          `You are ${currentAmountAwayFromFreeGift} USD away from ${currentProductFree}`;
        if (index > 0) {
          document.querySelector('.progress-tracker-heading h5').style.display = 'none';
          document.querySelector('.progress-tracker-heading span').textContent = `You have unlocked the: ${progressSteps[index - 1].getAttribute('data-product-title')}!`
        } else {
          document.querySelector('.progress-tracker-heading h5').style.display = 'block';
          document.querySelector('.progress-tracker-heading span').innerText = '';
        }
      }
      return; // Exit the loop since ongoing threshold is reached
    }
  });

  if (isLastStepCompleted) {
    document.querySelector('.progress-tracker-heading h5').style.display = 'none';
    document.querySelector('.progress-tracker-heading span').innerText = '';
    document.querySelector('.progress-tracker-heading p').textContent = `You have unlocked the gift item: ${lastProductTitle}!`;
  }
};

// Shopify theme customizer events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    window.slideCartComponent = new SlideCartComponent(
      'shopify-section-ee-slide-cart',
      'slide-cart--container',
      'site-nav__link--cart',
      'slide-cart-close-button',
    );
  });

  document.addEventListener('shopify:section:select', () => {
    window.slideCartComponent = new SlideCartComponent(
      'shopify-section-ee-slide-cart',
      'slide-cart--container',
      'site-nav__link--cart',
      'slide-cart-close-button',
    );
  });

  document.addEventListener('shopify:section:unload', () => {
    // Optionally cleanup or unbind events if needed
  });
}

const updateProductRecommendations = (newProductId) => {
  const productRecommendationsSection = document.querySelector('.slide-cart--product-recommendations');
  if (!productRecommendationsSection) {
    console.error('Product recommendations section not found.');
    return;
  }

  const urlString = productRecommendationsSection.dataset.url;
  if (!urlString) {
    console.error('Data URL is missing.');
    return;
  }

  try {
    // Construct the absolute URL
    const baseUrl = window.location.origin; // This gets the base URL of the current site
    const url = new URL(urlString, baseUrl); // Use the base URL to construct the full URL
    url.searchParams.set('product_id', newProductId);
    productRecommendationsSection.dataset.url = url.toString();
    fetchAndUpdateProductRecommendations();
  } catch (error) {
    console.error('DEBUG: Invalid URL:', error);
  }
};

const fetchAndUpdateProductRecommendations = () => {
  const productRecommendationsSection = document.querySelector('.slide-cart--product-recommendations');
  if (!productRecommendationsSection) {
    console.error('Product recommendations section not found.');
    return;
  }

  const url = productRecommendationsSection.dataset.url;
  if (!url) {
    console.error('Data URL is missing.');
    return;
  }

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.slide-cart--product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }

      handleUpsellDisplay();
    })
    .catch((e) => {
      console.error(e);
    });
};
